const state = {
}

const getters = {
}

// const types = {
// }

const mutations = {
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js